import * as React from 'react';
import './NotFound.scss';

export const NotFound = () => (
  <div className='not-found'>
    <div className="not-found__404">
      <div className="number">4</div>
      <div className="number cero"></div>
      <div className="number">4</div>
    </div>
    <div className="not-found__text">
      <p>This page isn´t here.</p>
      <p>Please don´t stare.</p>
    </div>
  </div>
);
